<style scoped>
td.comment {
  padding: 7px;
  background: #f5f5f5;
  /* border: 1px solid #CCCCCC; */
  /* margin-left: 45px; */
  border-radius: 15px;
  font-size: 13px;
  /* box-shadow: 0px 0px 3px #BBB; */
}
td.tdimage {
  width: 50px;
  vertical-align: top;
}
td.tdimage .profilePic {
  max-width: 30px;
  max-height: 30px;
}
td.like {
  font-size: 13px;
  width: 50px;
  text-align: center;
}
.comment .text {
  color: #333 !important;
}
.author {
  color: rgb(57, 57, 57);
  padding-right: 5px;
  font-size: 13px;
}
</style>
<template>
  <tr class="singleComment">
    <td class="padding10 tdimage">
      <img
        class="img-circle profilePic"
        :src="comment.author.profile_photo_url"
      />
    </td>
    <td class="comment">
      <strong class="author"
        ><span v-if="!comment.author.staff_type"
          ><strong>{{ comment.author.first_name }} </strong></span
        ><span v-if="comment.author.staff_type"
          >{{ comment.author.salutation }} </span
        >{{ comment.author.last_name }}</strong
      >
      <span class="text" v-html="comment.comment"></span>
      <div class="timeAgoDiv">
        <timeago :datetime="comment.created_timestamp * 1000"></timeago>
        <i
          @click="removeMyComment()"
          v-if="user_id == comment.user_id"
          class="pull-right far fa-trash-alt ng-scope"
        ></i>
        <!-- end ngIf: $root.user_id == comment.user_id -->
      </div>
    </td>
    <td class="like">
      <span
        class="align-middle"
        style="color: #21acf5"
        @click.stop="likeComment"
      >
        {{ comment.likes }}
        <i class="far fa-thumbs-up"></i>
      </span>
    </td>
  </tr>
</template>
<style scoped></style>
<script>
import ApiService from "@/services/ApiService";

export default {
  name: "singleComment",
  props: {
    comment: Object,
    user_id: Number,
  },
  data() {
    return {};
  },
  methods: {
    likeComment() {
      const _payload = {
        comment_id: this.comment.id,
      };

      ApiService.generalApi.likeComment(_payload).then((data) => {
        if (data.data > 0) {
          this.comment.likes++;
        }
      });
    },
    removeMyComment() {
      this.$emit("removeMyComment", this.comment.id);
    },
  },
};
</script>
